import React from 'react';
import '../../css/cards/MaterItem.css';

import { IoPlay } from 'react-icons/io5';

// import zbrush from '../../images/technologies/zbrush.png';
// import maya from '../../images/technologies/maya.png';
// import marmoset from '../../images/technologies/marmoset.png';
// import substance1 from '../../images/technologies/substance.png';
// import substance2 from '../../images/technologies/substance3.png';
// import unreal from '../../images/technologies/unreal.png';

import Image from 'react-image-webp';

import { openVideo } from '../../features/video';
import { useDispatch } from 'react-redux';

// let substance;

const MasterItem = ({ content }) => {
	const dispatch = useDispatch();

	// content.id !== '01' ? (substance = substance1) : (substance = substance2);
	// const software = [zbrush, maya, substance, marmoset, unreal];

	return (
		<div className='MasterItem'>
			<div className='item-header'>
				<div
					className='item-play'
					onClick={() => {
						// handleOpenModal(true);
						dispatch(
							openVideo({
								modal: true,
								url: content.video,
								type: 'common',
							})
						);
					}}
				>
					<IoPlay />
				</div>
				<h1 className='item-id'>{content.id}</h1>
				<div className='item-filter'></div>
				<Image webp={content.imageWebp} src={content.image} className='item-image' />
			</div>
			<div className='item-content'>
				<div className='item-information'>
					<h2 className='item-title'>{content.title}</h2>
					<p className='item-desc'>{content.description}</p>
				</div>
				<div className='item-software'>
					{content.software.map((element, index) => (
						<img key={index} src={element} alt='Software' />
					))}
				</div>
			</div>
		</div>
	);
};

export default MasterItem;
